<template>
  <div class="d-inline-block">
    <div>
      <div class="mt-10">
        <div class="d-inline-flex align-center mb-0">
          <p class="mb-0 mt-1 tabTitleFontSize font-weight-bold">
            탭 메뉴 노출 컬러
          </p>
          <v-btn
            depressed
            small
            color="#424242"
            class="examplePageButton font-weight-black mr-0 white--text ml-5 mb-0"
            aling="left"
            @click="showTabMenu()"
            >예제화면</v-btn
          >
        </div>
      </div>
    </div>
    <div>
      <div>
        <v-card width="620" outlined class="mt-3 d-flex">
          <v-card-text class="pa-0 ml-5 saleCardWidth">
            <p
              style="font-size: 0.9rem;"
              class="mb-1 mt-5 ml-0 font-weight-bold black--text"
            >
              탭 메뉴 텍스트 컬러 (선택시)
            </p>
            <div class="float-left">
              <v-row>
                <v-col class="d-flex justify-center">
                  <v-color-picker
                    mode="hexa"
                    hide-mode-switch
                    class="mb-3"
                    dot-size="16"
                    style="width: 270px;"
                    v-model="tab_font_color.selected"
                  ></v-color-picker>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-text class="pa-0 ml-5 saleCardWidth">
            <p
              style="font-size: 0.9rem;"
              class="mb-1 mt-5 ml-0 font-weight-bold black--text"
            >
              탭 메뉴 텍스트 컬러 (미선택시)
            </p>
            <div class="float-left">
              <v-row>
                <v-col class="d-flex justify-center">
                  <v-color-picker
                    mode="hexa"
                    hide-mode-switch
                    class="mb-3"
                    dot-size="16"
                    style="width: 270px;"
                    v-model="tab_font_color.unselected"
                  ></v-color-picker>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <div>
      <div class="mt-10">
        <div class="d-inline-flex align-center mb-0">
          <p class="mb-0 mt-1 tabTitleFontSize font-weight-bold">
            서비스 안내 페이지
          </p>
          <v-btn
            depressed
            small
            color="#424242"
            class="examplePageButton font-weight-black mr-0 white--text ml-5 mb-0"
            aling="left"
            @click="showServiceGuidePage()"
            >예제화면</v-btn
          >
        </div>
      </div>
    </div>
    <div>
      <v-card width="876" outlined class="mt-3 d-flex">
        <v-card-text class="pa-0 ml-5 d-inline-flex align-center mt-3 mb-3">
          <p class="mb-0 mr-5">소개 이미지</p>
          <div
            v-if="!mileage_detail_image_url"
            class="float-left d-inline-flex align-center"
          >
            <v-file-input
              id="service_guide_image"
              v-model="mileage_detail_image"
              class="mt-2 mb-2 float-left saleImageInputWidth"
              hide-details
              dense
              placeholder="클릭 - 쇼핑몰 가로 사이즈에 맞게 권장 / 5M 이하 / gif, png, jpg(jpeg)"
              accept="image/*"
              ref="product_image"
              @change="uploadGuideImageChange()"
            ></v-file-input>
            <v-btn
              depressed
              color="primary"
              class="font-weight-black mr-0 white--text ml-3 float-left"
              :disabled="upload_guide_image_button_disable"
              @click="uploadGuideImage()"
              >업로드</v-btn
            >
          </div>
          <div v-else class="float-left">
            <v-btn
              depressed
              small
              color="#7d7d7d"
              class="font-weight-black mr-0 white--text mt-0 mb-0"
              aling="left"
              @click="showServiceGuideImage()"
              >이미지 보기</v-btn
            >
            <v-icon
              color="#7d7d7d"
              class="ml-3 mt-0"
              @click="serviceGuideImageClose()"
              >mdi-close-circle</v-icon
            >
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div>
      <div class="mt-10">
        <div class="d-inline-flex align-center mb-0">
          <p class="mb-0 mt-1 tabTitleFontSize font-weight-bold">
            포인트 충전 페이지
          </p>
          <v-btn
            depressed
            small
            color="#424242"
            class="examplePageButton font-weight-black mr-0 white--text ml-5 mb-0"
            aling="left"
            @click="pointChargePage()"
            >예제화면</v-btn
          >
        </div>
      </div>
    </div>
    <div>
      <v-card width="876" outlined class="mt-3 d-flex">
        <v-card-text class="pa-0 ml-5 d-inline-flex align-center mt-3 mb-3">
          <p class="mb-0 mr-5">배너 이미지</p>
          <div
            v-if="!benner_image_url"
            class="float-left d-inline-flex align-center"
          >
            <v-file-input
              id="benner_image"
              v-model="mileage_charge.benner_image"
              class="mt-2 mb-2 float-left saleImageInputWidth"
              hide-details
              dense
              placeholder="클릭 - 쇼핑몰 가로 사이즈에 맞게 권장 / 5M 이하 / gif, png, jpg(jpeg)"
              accept="image/*"
              @change="uploadBennermageChange()"
            ></v-file-input>
            <v-btn
              depressed
              color="primary"
              class="font-weight-black mr-0 white--text ml-3 float-left"
              :disabled="upload_benner_image_button_disable"
              @click="uploadBennerImage()"
              >업로드</v-btn
            >
          </div>
          <div v-else class="float-left">
            <v-btn
              depressed
              small
              color="#7d7d7d"
              class="font-weight-black mr-0 white--text mt-0 mb-0"
              aling="left"
              @click="showBennerImageImage()"
              >이미지 보기</v-btn
            >
            <v-icon
              color="#7d7d7d"
              class="ml-3 mt-0"
              @click="bennerImageClose()"
              >mdi-close-circle</v-icon
            >
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div>
      <div>
        <v-card width="876" outlined class="mt-1 d-flex">
          <v-card-text class="pa-0 ml-5 saleCardWidth">
            <p
              style="font-size: 0.9rem;"
              class="mb-1 mt-5 ml-0 font-weight-bold black--text"
            >
              충전금액 버튼 컬러 (선택시)
            </p>
            <div class="float-left">
              <v-row>
                <v-col class="d-flex justify-center">
                  <v-color-picker
                    mode="hexa"
                    hide-mode-switch
                    class="mb-3"
                    dot-size="16"
                    style="width: 250px;"
                    v-model="mileage_charge.amount_button_color.selected"
                  ></v-color-picker>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-text class="pa-0 ml-5 saleCardWidth">
            <p
              style="font-size: 0.9rem;"
              class="mb-1 mt-5 ml-0 font-weight-bold black--text"
            >
              충전금액 버튼 컬러 (미선택시)
            </p>
            <div class="float-left">
              <v-row>
                <v-col class="d-flex justify-center">
                  <v-color-picker
                    mode="hexa"
                    hide-mode-switch
                    class="mb-3"
                    dot-size="16"
                    style="width: 250px;"
                    v-model="mileage_charge.amount_button_color.unselected"
                  ></v-color-picker>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-text class="pa-0 ml-5 saleCardWidth">
            <p
              style="font-size: 0.9rem;"
              class="mb-1 mt-5 ml-0 font-weight-bold black--text"
            >
              결제하기 버튼 컬러
            </p>
            <div class="float-left">
              <v-row>
                <v-col class="d-flex justify-center">
                  <v-color-picker
                    mode="hexa"
                    hide-mode-switch
                    class="mb-3"
                    dot-size="16"
                    style="width: 250px;"
                    v-model="mileage_charge.payment_button_color"
                  ></v-color-picker>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <div>
      <v-card width="876" outlined class="mt-1 d-flex">
        <v-card-text
          class="pa-0 ml-5 mr-5 d-inline-flex align-center mt-3 mb-3"
        >
          <p class="mb-0 mr-5">하단 안내 문구</p>
          <div class="float-left d-inline-flex align-center">
            <v-textarea
              class="mt-2 mb-2 float-left"
              hide-details
              dense
              style="font-size:15px; width: 720px;"
              placeholder="내용을 입력해주세요"
              outlined
              no-resize
              full-width
              v-model="mileage_charge.charge_bottom_contents"
            ></v-textarea>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div>
      <div class="mt-10">
        <div class="d-inline-flex align-center mb-0">
          <p class="mb-0 mt-1 tabTitleFontSize font-weight-bold">
            충전 내역 페이지
          </p>
          <v-btn
            depressed
            small
            color="#424242"
            class="examplePageButton font-weight-black mr-0 white--text ml-5 mb-0"
            aling="left"
            @click="showCharge()"
            >예제화면</v-btn
          >
        </div>
      </div>
    </div>
    <div>
      <v-card width="876" outlined class="mt-3 d-flex">
        <v-card-text
          class="pa-0 ml-5 mr-5 d-inline-flex align-center mt-3 mb-3"
        >
          <p class="mb-0 mr-5">하단 안내 문구</p>
          <div class="float-left d-inline-flex align-center">
            <v-textarea
              class="mt-2 mb-2 float-left"
              hide-details
              dense
              style="font-size:15px; width: 720px;"
              placeholder="내용을 입력해주세요"
              outlined
              no-resize
              full-width
              v-model="list_bottom_contents"
            ></v-textarea>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div class="mt-5 mb-3 float-right">
      <v-btn
        color="#8292ff"
        class="white--text mr-3"
        width="220"
        depressed
        right
        align="right"
        :disabled="preview_disabled"
        @click="pcPageView()"
        >쇼핑몰 적용 화면 미리보기</v-btn
      >
      <v-btn
        color="primary"
        width="350"
        depressed
        right
        align="right"
        @click="savePcDisplaySetting()"
        >저장하기</v-btn
      >
    </div>
  </div>
</template>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import M from "@/libs/mapping.js";
import Filters from "@/libs/filters.js";
import FileReader from "@tanker/file-reader";

export default {
  data: () => ({
    M,
    tab_font_color: {
      selected: null,
      unselected: null,
    },
    mileage_detail_image: null,
    mileage_charge: {
      benner_image: null,
      amount_button_color: {
        selected: null,
        unselected: null,
      },
      payment_button_color: null,
      charge_bottom_contents: null,
    },
    list_bottom_contents: null,

    upload_guide_image_button_disable: true,
    mileage_detail_image_url: null,
    benner_image_url: null,
    upload_benner_image_button_disable: true,
    preview_disabled: true,
  }),
  methods: {
    resetData: function() {
      Object.assign(this.$data, this.$options.data());
    },
    searchPcDisplaySetting: async function() {
      try {
        let result = await M.api(M.entry("/get/mileage/config/desktop"));

        this.tab_font_color = result.tab_font_color;
        this.mileage_detail_image = result.mileage_detail_image;
        this.mileage_charge = result.mileage_charge;
        this.list_bottom_contents = result.list_bottom_contents;

        if (result.mileage_detail_image) {
          this.mileage_detail_image_url = result.mileage_detail_image;
        } else {
          this.mileage_detail_image = null;
          this.mileage_detail_image_url = null;
        }

        if (result.mileage_charge.benner_image) {
          this.benner_image_url = result.mileage_charge.benner_image;
        } else {
          this.mileage_charge.benner_image = null;
          this.benner_image_url = null;
        }

        this.$emit("pcDisplaySetting", true);
        this.preview_disabled = false;
      } catch (e) {
        alert("쇼핑몰 PC 화면 설정 조회 실패했습니다.");
        this.$emit("pcDisplaySetting", false);
      }
    },
    savePcDisplaySetting: async function() {
      if (!this.mileage_detail_image_url) {
        alert("소개 이미지를 입력해주세요.");
        return false;
      }
      if (!this.benner_image_url) {
        alert("배너 이미지를 입력해주세요.");
        return false;
      }
      if (!this.mileage_charge.charge_bottom_contents) {
        alert("포인트 충전 페이지의 하단 안내 문구를 입력해주세요.");
        return false;
      }
      if (!this.list_bottom_contents) {
        alert("충전 내역 페이지의 하단 안내 문구를 입력해주세요.");
        return false;
      }

      this.mileage_charge.benner_image = this.benner_image_url;
      let setParams = {
        tab_font_color: this.tab_font_color,
        mileage_detail_image: this.mileage_detail_image_url,
        mileage_charge: this.mileage_charge,
        list_bottom_contents: this.list_bottom_contents,
      };
      try {
        await M.api(M.entry("/put/mileage/config/desktop"), setParams);
        this.preview_disabled = false;
        alert("쇼핑몰 PC 화면 설정 저장했습니다.");
      } catch (e) {
        alert("쇼핑몰 PC 화면 설정 저장 실패했습니다.");
      }
    },
    serviceGuideImageClose: function() {
      this.mileage_detail_image = null;
      this.mileage_detail_image_url = null;
      this.upload_guide_image_button_disable = true;
    },
    bennerImageClose: function() {
      this.mileage_charge.benner_image = null;
      this.benner_image_url = null;
      this.upload_benner_image_button_disable = true;
    },
    showServiceGuideImage: function() {
      let newTab = window.open();
      newTab.document.body.innerHTML =
        '<div><img src="' + this.mileage_detail_image_url + '" ></div>';
    },
    getImageSize: async function(image) {
      let _URL = window.URL || window.webkitURL;
      let objectUrl = _URL.createObjectURL(image);
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () =>
          resolve({
            width: img.width,
            height: img.height,
          });
        img.onerror = reject;
        img.src = objectUrl;
      });
    },

    uploadGuideImageChange: async function() {
      let maxSize = 5 * 1024 * 1024; //5MB

      if (this.mileage_detail_image) {
        if (this.mileage_detail_image.size >= maxSize) {
          this.mileage_detail_image = null;
          this.upload_guide_image_button_disable = true;
          alert("이미지 용량을 줄여주세요.");
          return false;
        }

        //let getImageSize = await this.getImageSize(this.mileage_detail_image);
        //if (getImageSize.width != 1280) {
        //this.mileage_detail_image = null;
        //alert("넓이 1280px으로 맞춰주세요.");
        //return false;
        //}

        this.upload_guide_image_button_disable = false;
      } else {
        this.upload_guide_image_button_disable = true;
      }
    },
    uploadGuideImage: async function() {
      let fileInfo = document.getElementById("service_guide_image").files[0];
      if (!fileInfo) {
        alert("상품 이미지를 등록해주세요.");
        return false;
      }
      const reader = new FileReader(fileInfo);
      const dataUrl = await reader.readAsDataURL();
      this.mileage_detail_image_url = dataUrl;

      alert("업로드 되었습니다");
    },
    showBennerImageImage: function() {
      let newTab = window.open();
      newTab.document.body.innerHTML =
        '<div><img src="' + this.benner_image_url + '" ></div>';
    },
    uploadBennerImage: async function() {
      let fileInfo = document.getElementById("benner_image").files[0];
      if (!fileInfo) {
        alert("상품 이미지를 등록해주세요.");
        return false;
      }
      const reader = new FileReader(fileInfo);
      const dataUrl = await reader.readAsDataURL();
      this.benner_image_url = dataUrl;

      alert("업로드 되었습니다");
    },
    uploadBennermageChange: async function() {
      let maxSize = 5 * 1024 * 1024; //5MB

      if (this.mileage_charge.benner_image) {
        if (this.mileage_charge.benner_image.size >= maxSize) {
          this.mileage_charge.benner_image = null;
          this.mileage_charge.benner_image = true;
          alert("이미지 용량을 줄여주세요.");
          return false;
        }

        this.upload_benner_image_button_disable = false;
      } else {
        this.upload_benner_image_button_disable = true;
      }
    },
    pcPageView: function() {
      window.open(
        `https://${this.$store.state.mallId}.cafe24.com/point.html?preview=1`,
        "_blank"
      );
    },
    showTabMenu: function() {
      window.open(`/images/pc1.jpg`, "_blank");
    },
    showServiceGuidePage: function() {
      window.open(`/images/pc1.jpg`, "_blank");
    },
    pointChargePage: function() {
      window.open(`/images/pc2.jpg`, "_blank");
    },
    showCharge: function() {
      window.open(`/images/pc3.jpg`, "_blank");
    },
  },
  mixins: [CommonMixin],
  filters: Filters,

  created: async function() {
    this.resetData();
    await this.searchPcDisplaySetting();
  },
};
</script>
